import React from "react";
import brand from "../brand";

const TermsCond = () => {
  return (
    <main className="page-shell legal-page">
      <section className="page-hero compact-hero">
        <span className="eyebrow">Terms</span>
        <h1>Terms and Conditions</h1>
        <p>
          By using {brand.name}, you agree to use the platform only for lawful
          result information and reference purposes.
        </p>
      </section>
      <section className="legal-copy">
        <p>
          The website does not conduct lottery activity or sell tickets. Result
          information is displayed for convenience and may rely on third-party or
          uploaded published material. Users should verify important information
          from official sources before making any decision.
        </p>
      </section>
    </main>
  );
};

export default TermsCond;
